import { useState, useEffect } from "react";

// ─────────────────────────────────────────────
//  CONFIGURACIÓN — edita estos valores
// ─────────────────────────────────────────────
const CONFIG = {
  N8N_WEBHOOK_URL: "https://TU-N8N.app.n8n.cloud/webhook/auracosmica-reserva", // ← pega tu URL de n8n aquí
  STRIPE_PAYMENT_LINK: "https://buy.stripe.com/3cIbIV5I2exx46RgvQdMI00",               // ← pega tu Payment Link de Stripe aquí
  EMAIL_CONTACTO: "saras@auracosmica.net",
};

const TESTIMONIALS = [
  { text: "La sesión fue un antes y un después. Ver mi carta natal explicada con tanta profundidad me ayudó a entender por qué me cuesta soltar el pasado y cómo transformar esa energía en fortaleza.", author: "Lucía M., Madrid" },
  { text: "Nunca había prestado atención a la astrología, pero la forma en que me explicó mis tránsitos actuales encajó perfectamente con todo lo que estaba viviendo. Me dio herramientas reales.", author: "Carlos R., Barcelona" },
  { text: "Llevo seis meses en el proceso de coaching astrológico y ha cambiado mi relación conmigo misma completamente. Es la mezcla perfecta de profundidad simbólica y aplicación práctica.", author: "Ana P., Valencia" },
];

const DAYS_ES   = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"];
const MONTHS_ES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

const ALL_SLOTS = [
  { time: "09:00", real: false },
  { time: "11:00", real: false },
  { time: "13:00", real: false },
  { time: "16:00", real: false },
  { time: "17:00", real: false },
  { time: "18:00", real: true  },
  { time: "20:00", real: true  },
];

function getWeekDates(offset) {
  const today = new Date(); today.setHours(0,0,0,0);
  const dow = today.getDay();
  const monday = new Date(today);
  monday.setDate(today.getDate() - (dow === 0 ? 6 : dow - 1) + offset * 7);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday); d.setDate(monday.getDate() + i); return d;
  });
}

// ─── Función que envía los datos al webhook de n8n ───
async function enviarReservaAN8N(datos) {
  const res = await fetch(CONFIG.N8N_WEBHOOK_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(datos),
  });
  if (!res.ok) throw new Error("Error al enviar la reserva");
}

// ─── Redirige a Stripe pasando datos en la URL ───
function irAPagoStripe(nombre, email, servicio) {
  const url = new URL(CONFIG.STRIPE_PAYMENT_LINK);
  url.searchParams.set("prefilled_email", email);
  url.searchParams.set("client_reference_id", `${servicio}-${Date.now()}`);
  window.open(url.toString(), "_blank");
}

// ═══════════════════════════════════════════════
//  CSS
// ═══════════════════════════════════════════════
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Cinzel:wght@400;600&family=Raleway:wght@300;400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #060812; }

  @keyframes rotateSlow { to { transform: rotate(-360deg); } }
  @keyframes pulse      { 0%,100%{opacity:.4} 50%{opacity:1} }
  @keyframes fadeUp     { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:none} }
  @keyframes spin       { to{transform:rotate(360deg)} }

  .star-bg {
    position:fixed; inset:0; pointer-events:none; z-index:0;
    background-image:
      radial-gradient(1px 1px at 10% 15%,rgba(255,255,255,.6) 0%,transparent 100%),
      radial-gradient(1px 1px at 30% 8%,rgba(255,255,255,.4) 0%,transparent 100%),
      radial-gradient(1.5px 1.5px at 60% 20%,rgba(201,168,76,.5) 0%,transparent 100%),
      radial-gradient(1px 1px at 85% 12%,rgba(255,255,255,.5) 0%,transparent 100%),
      radial-gradient(1px 1px at 20% 55%,rgba(255,255,255,.3) 0%,transparent 100%),
      radial-gradient(1px 1px at 75% 45%,rgba(255,255,255,.4) 0%,transparent 100%),
      radial-gradient(1.5px 1.5px at 5% 70%,rgba(201,168,76,.3) 0%,transparent 100%),
      radial-gradient(1px 1px at 50% 82%,rgba(255,255,255,.4) 0%,transparent 100%),
      radial-gradient(1px 1px at 92% 78%,rgba(255,255,255,.3) 0%,transparent 100%),
      radial-gradient(1px 1px at 40% 95%,rgba(201,168,76,.3) 0%,transparent 100%);
  }

  /* NAV */
  .nav { position:fixed;top:0;left:0;right:0;z-index:100;display:flex;justify-content:space-between;align-items:center;padding:1.2rem 2.5rem;background:linear-gradient(to bottom,rgba(6,8,18,.97),transparent);backdrop-filter:blur(6px); }
  .nav-logo { font-family:'Cinzel',serif;font-size:.95rem;letter-spacing:.2em;color:#c9a84c; }
  .nav-links { display:flex;gap:2rem; }
  .nav-links button { background:none;border:none;color:#a8b4d0;cursor:pointer;font-family:'Raleway',sans-serif;font-size:.72rem;letter-spacing:.15em;text-transform:uppercase;padding:0;transition:color .3s; }
  .nav-links button:hover { color:#e8c97e; }
  .hamburger { display:none;background:none;border:none;cursor:pointer;flex-direction:column;gap:5px;padding:4px; }
  .hamburger span { display:block;width:22px;height:1px;background:#c9a84c; }
  .mobile-menu { display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:99;background:rgba(6,8,18,.97);flex-direction:column;align-items:center;justify-content:center;gap:2.5rem; }
  .mobile-menu.open { display:flex;animation:fadeUp .3s ease; }
  .mobile-menu button { background:none;border:none;color:#a8b4d0;cursor:pointer;font-family:'Cinzel',serif;font-size:1.1rem;letter-spacing:.2em;text-transform:uppercase;transition:color .3s; }
  .mobile-menu button:hover { color:#e8c97e; }
  .mobile-close { position:absolute;top:1.5rem;right:2rem;background:none;border:none;color:#c9a84c;font-size:1.5rem;cursor:pointer; }

  /* HERO */
  .hero { min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:8rem 1.5rem 4rem;position:relative;z-index:1; }
  .hero-glow { position:absolute;top:50%;left:50%;transform:translate(-50%,-60%);width:600px;height:600px;background:radial-gradient(ellipse,rgba(201,168,76,.07) 0%,transparent 65%);pointer-events:none; }
  .wheel-wrap { position:relative;width:180px;height:180px;margin-bottom:2rem; }
  .wheel-svg  { width:100%;height:100%;animation:rotateSlow 80s linear infinite; }
  .wheel-symbol { position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:2.8rem;color:#c9a84c;animation:pulse 4s ease-in-out infinite; }
  .eyebrow { font-family:'Cinzel',serif;font-size:.58rem;letter-spacing:.4em;text-transform:uppercase;color:#c9a84c;margin-bottom:.9rem; }
  .hero h1 { font-family:'Cormorant Garamond',serif;font-size:clamp(2.6rem,7vw,5.5rem);font-weight:300;line-height:1.08;color:#f0eee8;margin-bottom:1.1rem; }
  .hero h1 em { font-style:italic;color:#e8c97e; }
  .hero-sub { font-family:'Cormorant Garamond',serif;font-size:clamp(1rem,2.5vw,1.2rem);font-style:italic;color:#a8b4d0;max-width:500px;line-height:1.75;margin-bottom:2.2rem; }
  .cta-btn { padding:.9rem 2.8rem;border:1px solid #c9a84c;background:transparent;color:#c9a84c;font-family:'Cinzel',serif;font-size:.62rem;letter-spacing:.25em;text-transform:uppercase;cursor:pointer;transition:all .4s; }
  .cta-btn:hover { background:#c9a84c;color:#060812; }

  /* SECTIONS */
  .section { position:relative;z-index:1;max-width:1100px;margin:0 auto;padding:5rem 2rem; }
  .section-label { font-family:'Cinzel',serif;font-size:.56rem;letter-spacing:.4em;text-transform:uppercase;color:#c9a84c;margin-bottom:.7rem; }
  .sec-h2 { font-family:'Cormorant Garamond',serif;font-size:clamp(1.9rem,4vw,3.2rem);font-weight:300;color:#f0eee8;line-height:1.15;margin-bottom:1.4rem; }
  .sec-h2 em { font-style:italic;color:#e8c97e; }
  .body-text { font-size:.93rem;line-height:1.9;color:#c8c0b0; }
  .about-grid { display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center; }
  .about-visual { display:flex;align-items:center;justify-content:center; }

  /* SERVICES */
  .services-band { position:relative;z-index:1;background:linear-gradient(180deg,transparent,rgba(17,22,56,.35) 20%,rgba(17,22,56,.35) 80%,transparent);padding:5rem 2rem; }
  .services-inner { max-width:1100px;margin:0 auto; }
  .services-header { text-align:center;margin-bottom:2.5rem; }
  .services-grid { display:grid;grid-template-columns:repeat(3,1fr);border:1px solid rgba(201,168,76,.15); }
  .scard { padding:2.5rem 2rem;border-right:1px solid rgba(201,168,76,.15);transition:background .4s;cursor:default; }
  .scard:last-child { border-right:none; }
  .scard:hover { background:rgba(201,168,76,.05); }
  .scard-icon { font-size:1.7rem;margin-bottom:1rem;display:block; }
  .scard h3 { font-family:'Cormorant Garamond',serif;font-size:1.45rem;font-weight:400;color:#f0eee8;margin-bottom:.7rem; }
  .scard p { font-size:.87rem;line-height:1.8;color:#a8b4d0; }
  .scard-price { display:inline-block;margin-top:1.3rem;padding:.35rem 1.1rem;border:1px solid rgba(201,168,76,.4);font-family:'Cinzel',serif;font-size:.58rem;letter-spacing:.2em;color:#c9a84c; }

  /* TESTIMONIALS */
  .testi-section { position:relative;z-index:1;text-align:center;padding:5rem 2rem;max-width:800px;margin:0 auto; }
  .testi-quote { font-family:'Cormorant Garamond',serif;font-size:clamp(1.1rem,2.5vw,1.75rem);font-style:italic;font-weight:300;color:#f0eee8;line-height:1.7;margin-bottom:1.1rem; }
  .testi-author { font-family:'Cinzel',serif;font-size:.56rem;letter-spacing:.3em;color:#c9a84c;text-transform:uppercase; }
  .testi-dots { display:flex;justify-content:center;gap:.5rem;margin-top:1.5rem; }
  .dot { width:7px;height:7px;border-radius:50%;cursor:pointer;transition:background .3s; }

  /* BOOKING */
  .booking-band { position:relative;z-index:1;padding:5rem 2rem;background:radial-gradient(ellipse at center,rgba(17,22,56,.5) 0%,transparent 65%); }
  .booking-inner { max-width:740px;margin:0 auto; }
  .booking-header { text-align:center;margin-bottom:2.8rem; }
  .booking-header .sub { color:#a8b4d0;font-size:.87rem;margin-top:.9rem;line-height:1.8; }

  /* FORM */
  .form-grid { display:grid;grid-template-columns:1fr 1fr;gap:1.2rem; }
  .field { display:flex;flex-direction:column;gap:.45rem; }
  .field.full { grid-column:1/-1; }
  .field label { font-family:'Cinzel',serif;font-size:.56rem;letter-spacing:.2em;text-transform:uppercase;color:#c9a84c; }
  .field input,.field select,.field textarea { background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.25);color:#f0eee8;padding:.85rem 1rem;font-family:'Raleway',sans-serif;font-size:.88rem;font-weight:300;outline:none;width:100%;transition:border-color .3s,background .3s;color-scheme:dark; }
  .field input:focus,.field select:focus,.field textarea:focus { border-color:#c9a84c;background:rgba(201,168,76,.04); }
  .field textarea { resize:vertical; }

  /* CALENDAR */
  .cal-box { border:1px solid rgba(201,168,76,.2);padding:1.2rem;background:rgba(6,8,18,.5); }
  .cal-nav { display:flex;align-items:center;justify-content:space-between;margin-bottom:.75rem; }
  .cal-nav button { background:none;border:1px solid rgba(201,168,76,.3);color:#c9a84c;width:28px;height:28px;cursor:pointer;font-size:1rem;line-height:1; }
  .cal-nav span { font-family:'Cinzel',serif;font-size:.56rem;letter-spacing:.12em;color:#a8b4d0; }
  .days-grid { display:grid;grid-template-columns:repeat(7,1fr);gap:4px; }
  .day-cell { aspect-ratio:1;display:flex;flex-direction:column;align-items:center;justify-content:center;border:1px solid transparent;border-radius:2px;transition:all .2s; }
  .day-cell.avail { cursor:pointer; }
  .day-cell.avail:hover { border-color:rgba(201,168,76,.5);background:rgba(201,168,76,.07); }
  .day-cell.sel-day { border-color:#c9a84c!important;background:rgba(201,168,76,.12)!important; }
  .day-cell.unavail { opacity:.25;cursor:not-allowed; }
  .day-name { font-family:'Cinzel',serif;font-size:.4rem;letter-spacing:.04em;color:#a8b4d0;margin-bottom:2px; }
  .day-dot  { width:4px;height:4px;border-radius:50%;background:#c9a84c;margin-top:3px;opacity:.6; }

  /* TIME SLOTS */
  .slots-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:8px; }
  .slot { padding:.6rem;text-align:center;font-family:'Cinzel',serif;font-size:.6rem;letter-spacing:.08em;transition:all .2s;border:1px solid transparent; }
  .slot.avail-s { border-color:rgba(201,168,76,.3);color:#e8c97e;cursor:pointer; }
  .slot.avail-s:hover { border-color:#c9a84c;background:rgba(201,168,76,.1); }
  .slot.occupied { border-color:rgba(168,180,208,.1);color:rgba(168,180,208,.22);text-decoration:line-through;cursor:not-allowed;font-size:.55rem; }
  .slot.sel-slot { border-color:#c9a84c;background:rgba(201,168,76,.15);color:#c9a84c; }

  /* BANNERS */
  .info-banner { display:flex;align-items:center;gap:1rem;padding:1rem 1.2rem;border:1px solid rgba(201,168,76,.2);background:rgba(201,168,76,.03); }
  .info-banner p { font-size:.82rem;color:#a8b4d0;line-height:1.6; }
  .info-banner strong { color:#e8c97e;font-weight:400; }

  /* PASOS DE PAGO */
  .steps { display:flex;gap:0;border:1px solid rgba(201,168,76,.15); }
  .step { flex:1;padding:1rem;display:flex;align-items:center;gap:.7rem;border-right:1px solid rgba(201,168,76,.15); }
  .step:last-child { border-right:none; }
  .step-num { width:24px;height:24px;border-radius:50%;border:1px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Cinzel',serif;font-size:.5rem;color:#c9a84c;flex-shrink:0; }
  .step-txt { font-size:.75rem;color:#a8b4d0;line-height:1.4; }
  .step-txt strong { display:block;color:#e8c97e;font-weight:400;font-size:.7rem;margin-bottom:1px; }

  /* BOTONES */
  .submit-wrap { display:flex;flex-direction:column;align-items:center;gap:.8rem;margin-top:.5rem; }
  .submit-btn { padding:1rem 3.5rem;background:transparent;border:1px solid #c9a84c;color:#c9a84c;font-family:'Cinzel',serif;font-size:.62rem;letter-spacing:.3em;text-transform:uppercase;cursor:pointer;transition:all .4s;width:100%;max-width:360px; }
  .submit-btn:hover:not(:disabled) { background:#c9a84c;color:#060812; }
  .submit-btn:disabled { opacity:.5;cursor:not-allowed; }
  .pay-btn { padding:1rem 3.5rem;background:#c9a84c;border:1px solid #c9a84c;color:#060812;font-family:'Cinzel',serif;font-size:.62rem;letter-spacing:.3em;text-transform:uppercase;cursor:pointer;transition:all .4s;width:100%;max-width:360px; }
  .pay-btn:hover { background:#e8c97e;border-color:#e8c97e; }
  .privacy { font-size:.7rem;color:rgba(168,180,208,.4);text-align:center; }
  .err-msg { color:#e8a0a0;font-size:.8rem;text-align:center;font-family:'Raleway',sans-serif;grid-column:1/-1; }

  /* LOADING SPINNER */
  .spinner { width:18px;height:18px;border:2px solid rgba(201,168,76,.3);border-top-color:#c9a84c;border-radius:50%;animation:spin .7s linear infinite;display:inline-block;vertical-align:middle;margin-right:8px; }

  /* SUCCESS */
  .success-box { animation:fadeUp .6s ease; }
  .success-card { text-align:center;padding:2.5rem 2rem;border:1px solid rgba(201,168,76,.3);background:rgba(201,168,76,.04);margin-bottom:1.5rem; }
  .success-card h3 { font-family:'Cormorant Garamond',serif;font-size:2rem;font-weight:300;color:#f0eee8;margin-bottom:.8rem; }
  .success-card p { color:#a8b4d0;line-height:1.8; }
  .success-card strong { color:#e8c97e;font-weight:400; }
  .pay-card { padding:1.5rem 2rem;border:1px solid rgba(201,168,76,.4);background:rgba(201,168,76,.06);display:flex;flex-direction:column;align-items:center;gap:1rem; }
  .pay-card p { font-size:.85rem;color:#a8b4d0;text-align:center;line-height:1.7; }
  .pay-card .amount { font-family:'Cormorant Garamond',serif;font-size:2.5rem;color:#e8c97e;font-weight:300; }

  /* FOOTER */
  footer { position:relative;z-index:1;text-align:center;padding:2.5rem 2rem;border-top:1px solid rgba(201,168,76,.1); }
  footer p { font-family:'Cinzel',serif;font-size:.5rem;letter-spacing:.2em;color:rgba(168,180,208,.3); }
  footer p+p { margin-top:.4rem; }
  footer a { color:rgba(201,168,76,.5);text-decoration:none; }
  footer a:hover { color:#c9a84c; }

  /* RESPONSIVE */
  @media (max-width:768px) {
    .nav { padding:1rem 1.2rem; }
    .nav-links { display:none; }
    .hamburger { display:flex; }
    .hero-glow { width:280px;height:280px; }
    .wheel-wrap { width:140px;height:140px; }
    .wheel-symbol { font-size:2.2rem; }
    .about-grid { grid-template-columns:1fr;gap:2rem; }
    .about-visual { display:none; }
    .services-grid { grid-template-columns:1fr;border:none;gap:8px; }
    .scard { border-right:none;border:1px solid rgba(201,168,76,.15); }
    .form-grid { grid-template-columns:1fr; }
    .slots-grid { grid-template-columns:repeat(2,1fr); }
    .steps { flex-direction:column;gap:0; }
    .step { border-right:none;border-bottom:1px solid rgba(201,168,76,.15); }
    .step:last-child { border-bottom:none; }
    .hero,.section,.services-band,.booking-band,.testi-section { padding:3.5rem 1.2rem; }
    .hero { padding-top:6rem; }
  }
  @media (max-width:420px) {
    .day-name { font-size:.36rem; }
    .cal-nav span { font-size:.46rem; }
    .slot { padding:.5rem .25rem;font-size:.55rem; }
    .slot.occupied { font-size:.5rem; }
  }
`;

// ═══════════════════════════════════════════════
//  COMPONENTE PRINCIPAL
// ═══════════════════════════════════════════════
export default function App() {
  const [testiIdx,     setTestiIdx]     = useState(0);
  const [weekOffset,   setWeekOffset]   = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [step,         setStep]         = useState("form");   // "form" | "success"
  const [loading,      setLoading]      = useState(false);
  const [form,         setForm]         = useState({ nombre:"", email:"", nacimiento:"", horaNac:"", lugar:"", servicio:"", mensaje:"" });
  const [error,        setError]        = useState("");
  const [menuOpen,     setMenuOpen]     = useState(false);

  useEffect(() => {
    const t = setInterval(() => setTestiIdx(i => (i+1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, []);

  const today     = new Date(); today.setHours(0,0,0,0);
  const weekDates = getWeekDates(weekOffset);
  const isAvail   = d => d.getDay() >= 1 && d.getDay() <= 5 && d >= today;

  const scrollTo = id => { document.getElementById(id)?.scrollIntoView({ behavior:"smooth" }); setMenuOpen(false); };

  const handleSubmit = async () => {
    if (!form.nombre || !form.email || !form.nacimiento || !form.servicio) {
      setError("Por favor completa nombre, email, fecha de nacimiento y tipo de consulta."); return;
    }
    if (!selectedDate || !selectedTime) {
      setError("Por favor selecciona una fecha y hora para tu sesión."); return;
    }
    setError("");
    setLoading(true);

    const payload = {
      ...form,
      fecha_sesion: selectedDate.toLocaleDateString("es-ES", { weekday:"long", day:"numeric", month:"long", year:"numeric" }),
      hora_sesion:  selectedTime,
      precio:       "150 €",
      email_coach:  CONFIG.EMAIL_CONTACTO,
      timestamp:    new Date().toISOString(),
    };

    try {
      await enviarReservaAN8N(payload);
    } catch (e) {
      // Si n8n no está configurado aún, seguimos igualmente (modo demo)
      console.warn("n8n no configurado:", e.message);
    }

    setLoading(false);
    setStep("success");
  };

  const handlePago = () => irAPagoStripe(form.nombre, form.email, form.servicio);

  // ─── RENDER ───
  return (
    <div style={{ fontFamily:"'Raleway',sans-serif", background:"#060812", color:"#c8c0b0", minHeight:"100vh", overflowX:"hidden" }}>
      <style>{CSS}</style>
      <div className="star-bg" />

      {/* NAV */}
      <nav className="nav">
        <span className="nav-logo">✦ Aura Cósmica</span>
        <div className="nav-links">
          {[["sobre-mi","Sobre mí"],["servicios","Servicios"],["reserva","Reservar"]].map(([id,lbl]) => (
            <button key={id} onClick={() => scrollTo(id)}>{lbl}</button>
          ))}
        </div>
        <button className="hamburger" onClick={() => setMenuOpen(true)} aria-label="Menú">
          <span/><span/><span/>
        </button>
      </nav>
      <div className={`mobile-menu${menuOpen?" open":""}`}>
        <button className="mobile-close" onClick={() => setMenuOpen(false)}>✕</button>
        {[["sobre-mi","Sobre mí"],["servicios","Servicios"],["reserva","Reservar"]].map(([id,lbl]) => (
          <button key={id} onClick={() => scrollTo(id)}>{lbl}</button>
        ))}
      </div>

      {/* HERO */}
      <section className="hero">
        <div className="hero-glow" />
        <div className="wheel-wrap">
          <svg className="wheel-svg" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="95" stroke="rgba(201,168,76,.25)" strokeWidth=".5"/>
            <circle cx="100" cy="100" r="72" stroke="rgba(201,168,76,.15)" strokeWidth=".5" strokeDasharray="3 7"/>
            <circle cx="100" cy="100" r="50" stroke="rgba(201,168,76,.1)"  strokeWidth=".5"/>
            {[0,30,60,90,120,150,180,210,240,270,300,330].map(a => {
              const r=a*Math.PI/180;
              return <line key={a} x1={100+88*Math.sin(r)} y1={100-88*Math.cos(r)} x2={100+96*Math.sin(r)} y2={100-96*Math.cos(r)} stroke="rgba(201,168,76,.5)" strokeWidth="1"/>;
            })}
            {["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"].map((s,i) => {
              const a=(i*30-90)*Math.PI/180;
              return <text key={i} x={100+80*Math.cos(a)} y={100+80*Math.sin(a)+4} textAnchor="middle" fill="rgba(201,168,76,.6)" fontSize="9">{s}</text>;
            })}
          </svg>
          <div className="wheel-symbol">☽</div>
        </div>
        <p className="eyebrow">Coach Astrológico · Consultas Personalizadas</p>
        <h1>Tu cielo natal,<br/><em>tu guía interior</em></h1>
        <p className="hero-sub">Descifra el mensaje de los astros en el momento exacto de tu nacimiento y transforma esa sabiduría en acción consciente.</p>
        <button className="cta-btn" onClick={() => scrollTo("reserva")}>Reservar consulta</button>
      </section>

      {/* ABOUT */}
      <section id="sobre-mi" className="section">
        <div className="about-grid">
          <div>
            <p className="section-label">Sobre mí</p>
            <h2 className="sec-h2">El cosmos habla.<br/><em>Yo lo traduzco.</em></h2>
            <p className="body-text">Llevo más de una década estudiando la astrología como lenguaje simbólico del alma. Mi enfoque no es predictivo sino transformador: trabajo contigo para que comprendas los ciclos planetarios que atraviesas, identifiques tus patrones y tomes decisiones alineadas con quien verdaderamente eres.</p>
            <p className="body-text" style={{marginTop:"1.2rem"}}>Cada consulta es un espacio íntimo de reflexión y claridad, donde tu carta natal se convierte en el mapa de tu potencial más profundo.</p>
          </div>
          <div className="about-visual">
            <svg viewBox="0 0 300 300" style={{width:270,height:270,opacity:.8}}>
              <circle cx="150" cy="150" r="142" stroke="rgba(201,168,76,.2)"  strokeWidth=".5" fill="none"/>
              <circle cx="150" cy="150" r="115" stroke="rgba(201,168,76,.15)" strokeWidth=".5" fill="none"/>
              <circle cx="150" cy="150" r="85"  stroke="rgba(201,168,76,.1)"  strokeWidth=".5" fill="none"/>
              <circle cx="150" cy="150" r="55"  stroke="rgba(201,168,76,.07)" strokeWidth=".5" fill="none"/>
              {[0,30,60,90,120,150,180,210,240,270,300,330].map(a => {
                const r=a*Math.PI/180;
                return <line key={a} x1={150+55*Math.sin(r)} y1={150-55*Math.cos(r)} x2={150+142*Math.sin(r)} y2={150-142*Math.cos(r)} stroke="rgba(201,168,76,.1)" strokeWidth=".5"/>;
              })}
              {["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓"].map((s,i) => {
                const a=(i*30-90)*Math.PI/180;
                return <text key={i} x={150+128*Math.cos(a)} y={150+128*Math.sin(a)+4} textAnchor="middle" fill="rgba(201,168,76,.55)" fontSize="12">{s}</text>;
              })}
              {[[150,68],[218,95],[228,178],[180,238],[95,242],[52,180],[55,105]].map(([x,y],i)=>(
                <circle key={i} cx={x} cy={y} r={i%2===0?4:3} fill={i%3===0?"rgba(201,168,76,.8)":"rgba(168,180,208,.7)"}/>
              ))}
              <polygon points="150,68 218,95 228,178 180,238 95,242 52,180 55,105" fill="none" stroke="rgba(201,168,76,.15)" strokeWidth=".5"/>
            </svg>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <div className="services-band" id="servicios">
        <div className="services-inner">
          <div className="services-header">
            <p className="section-label">Servicios</p>
            <h2 className="sec-h2">Consultas <em>diseñadas</em><br/>para tu momento</h2>
          </div>
          <div className="services-grid">
            {[
              {icon:"🌑",title:"Carta Natal",desc:"Análisis profundo de tu mapa astral de nacimiento. Descubrimos tus dones, sombras, propósito y patrones de vida inscritos en el momento en que llegaste al mundo."},
              {icon:"🌊",title:"Tránsitos & Ciclos",desc:"¿Qué te está pidiendo el cielo ahora? Estudiamos los planetas en movimiento sobre tu carta y diseñamos una estrategia de vida para el período que atraviesas."},
              {icon:"✦",title:"Coaching Astrológico",desc:"Proceso de acompañamiento donde la astrología se convierte en herramienta de autoconocimiento, toma de decisiones y transformación personal."},
            ].map((s,i) => (
              <div key={i} className="scard">
                <span className="scard-icon">{s.icon}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <span className="scard-price">Sesión 2h · 150 €</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="testi-section">
        <p className="section-label" style={{marginBottom:"2rem"}}>Testimonios</p>
        <p className="testi-quote">"{TESTIMONIALS[testiIdx].text}"</p>
        <p className="testi-author">— {TESTIMONIALS[testiIdx].author}</p>
        <div className="testi-dots">
          {TESTIMONIALS.map((_,i) => (
            <div key={i} className="dot" onClick={()=>setTestiIdx(i)} style={{background:i===testiIdx?"#c9a84c":"rgba(201,168,76,.25)"}}/>
          ))}
        </div>
      </div>

      {/* BOOKING */}
      <div className="booking-band" id="reserva">
        <div className="booking-inner">
          <div className="booking-header">
            <p className="section-label">Reserva tu sesión</p>
            <h2 className="sec-h2">El momento<br/><em>perfecto te espera</em></h2>
            <p className="sub">Rellena el formulario, elige tu horario y completa el pago seguro.<br/>Recibirás la confirmación en tu correo al instante.</p>
          </div>

          {/* PASOS */}
          <div className="steps" style={{marginBottom:"2rem"}}>
            {[
              {n:"1", title:"Datos & horario",  desc:"Rellena el formulario y elige fecha"},
              {n:"2", title:"Confirmación",      desc:"Recibes email automático al instante"},
              {n:"3", title:"Pago seguro",       desc:"150 € · Stripe · tarjeta o Bizum"},
            ].map(s => (
              <div key={s.n} className="step">
                <div className="step-num">{s.n}</div>
                <div className="step-txt"><strong>{s.title}</strong>{s.desc}</div>
              </div>
            ))}
          </div>

          {step === "form" ? (
            <div className="form-grid">
              {/* Campos */}
              <div className="field">
                <label>Nombre completo</label>
                <input type="text" placeholder="Tu nombre y apellidos" value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})}/>
              </div>
              <div className="field">
                <label>Correo electrónico</label>
                <input type="email" placeholder="hola@tumail.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/>
              </div>
              <div className="field">
                <label>✦ Fecha de nacimiento</label>
                <input type="date" max="2006-01-01" value={form.nacimiento} onChange={e=>setForm({...form,nacimiento:e.target.value})}/>
              </div>
              <div className="field">
                <label>Hora de nacimiento (si la conoces)</label>
                <input type="time" value={form.horaNac} onChange={e=>setForm({...form,horaNac:e.target.value})}/>
              </div>
              <div className="field">
                <label>Lugar de nacimiento</label>
                <input type="text" placeholder="Ciudad, País" value={form.lugar} onChange={e=>setForm({...form,lugar:e.target.value})}/>
              </div>
              <div className="field">
                <label>Tipo de consulta</label>
                <select value={form.servicio} onChange={e=>setForm({...form,servicio:e.target.value})}>
                  <option value="">Selecciona el servicio</option>
                  <option value="Carta Natal">Carta Natal · 150 €</option>
                  <option value="Tránsitos & Ciclos">Tránsitos & Ciclos · 150 €</option>
                  <option value="Coaching Astrológico">Coaching Astrológico · 150 €</option>
                </select>
              </div>

              {/* Calendario */}
              <div className="field full">
                <label>Selecciona una fecha disponible</label>
                <div className="cal-box">
                  <div className="cal-nav">
                    <button onClick={()=>weekOffset>0&&setWeekOffset(w=>w-1)}>‹</button>
                    <span>{weekDates[0].getDate()} {MONTHS_ES[weekDates[0].getMonth()].slice(0,3)} – {weekDates[6].getDate()} {MONTHS_ES[weekDates[6].getMonth()].slice(0,3)} {weekDates[6].getFullYear()}</span>
                    <button onClick={()=>weekOffset<12&&setWeekOffset(w=>w+1)}>›</button>
                  </div>
                  <div className="days-grid">
                    {weekDates.map((date,i) => {
                      const av  = isAvail(date);
                      const sel = selectedDate && date.toDateString()===selectedDate.toDateString();
                      return (
                        <div key={i} className={`day-cell ${av?"avail":"unavail"} ${sel?"sel-day":""}`}
                          onClick={()=>av&&(setSelectedDate(date),setSelectedTime(null))}>
                          <span className="day-name">{DAYS_ES[date.getDay()]}</span>
                          <span className="day-num" style={{fontSize:".75rem",color:av?"#e8c97e":"#c8c0b0"}}>{date.getDate()}</span>
                          {av && <span className="day-dot"/>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Horarios */}
              {selectedDate && (
                <div className="field full">
                  <label>Horario — {DAYS_ES[selectedDate.getDay()]} {selectedDate.getDate()} de {MONTHS_ES[selectedDate.getMonth()]}</label>
                  <div className="slots-grid">
                    {ALL_SLOTS.map((slot,i) => {
                      const isSel = selectedTime===slot.time;
                      return (
                        <div key={i} className={`slot ${slot.real?(isSel?"sel-slot":"avail-s"):"occupied"}`}
                          onClick={()=>slot.real&&setSelectedTime(slot.time)}>
                          {slot.real ? slot.time : `${slot.time} Ocupado`}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Info */}
              <div className="field full">
                <div className="info-banner">
                  <span style={{fontSize:"1.1rem",flexShrink:0}}>✦</span>
                  <p>Sesión de <strong>2 horas</strong> · <strong>150 €</strong> · Videollamada · Lunes a viernes a partir de las <strong>18:00 h</strong></p>
                </div>
              </div>

              {/* Mensaje */}
              <div className="field full">
                <label>¿Qué te gustaría trabajar en esta sesión?</label>
                <textarea rows={4} placeholder="Cuéntame qué está pasando en tu vida, qué preguntas traes, en qué área necesitas más luz..." value={form.mensaje} onChange={e=>setForm({...form,mensaje:e.target.value})}/>
              </div>

              {error && <p className="err-msg">{error}</p>}

              <div className="field full submit-wrap">
                <button className="submit-btn" onClick={handleSubmit} disabled={loading}>
                  {loading && <span className="spinner"/>}
                  <span>{loading ? "Enviando reserva..." : "Confirmar reserva →"}</span>
                </button>
                <p className="privacy">Tu información es confidencial. Al confirmar pasarás al pago seguro con Stripe.</p>
              </div>
            </div>
          ) : (
            /* PASO 2 — ÉXITO + PAGO */
            <div className="success-box">
              <div className="success-card">
                <div style={{fontSize:"2.2rem",marginBottom:"1rem"}}>✦</div>
                <h3>¡Reserva recibida!</h3>
                <p>
                  Gracias, <strong>{form.nombre.split(" ")[0]}</strong>. Hemos enviado los detalles de tu sesión a <strong>{form.email}</strong> y a {CONFIG.EMAIL_CONTACTO}.<br/><br/>
                  <strong>{form.servicio}</strong> · {selectedDate?.toLocaleDateString("es-ES",{weekday:"long",day:"numeric",month:"long"})} · {selectedTime} h
                </p>
              </div>
              <div className="pay-card">
                <p>Para confirmar definitivamente tu plaza, completa el pago a continuación.<br/>Es seguro y rápido — admite tarjeta, Google Pay y Bizum.</p>
                <div className="amount">150 €</div>
                <button className="pay-btn" onClick={handlePago}>
                  💳 &nbsp;Pagar ahora con Stripe
                </button>
                <p style={{fontSize:".72rem",color:"rgba(168,180,208,.4)"}}>Se abrirá la pasarela de pago en una nueva ventana.</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* FOOTER */}
      <footer>
        <p>© 2025 AURA CÓSMICA · COACH ASTROLÓGICO · BARCELONA</p>
        <p><a href={`mailto:${CONFIG.EMAIL_CONTACTO}`}>{CONFIG.EMAIL_CONTACTO}</a> · Sesiones por videollamada</p>
      </footer>
    </div>
  );
}
